// extracted by mini-css-extract-plugin
export default {"url":"EAhq7MPkQX"};